type Environment = 'production' | 'staging' | 'development';
const file = (process.env.NODE_ENV || 'development') as Environment;

type Settings = {
  [key in Environment]: {
    api: {
      'api-help-center': string;
      'blip-api': string;
      'authz-api': string;
      'ticket-mobile': string;
      'api-tickets': string;
      'api-conversations': string;
    };
    app: {
      backoffice: string;
    };
    keys: {
      BLIP_BW: string;
      ZENDESK_KEY: string;
      ZENDESK_ASYNC_KEY: string;
      ZENDESK_CAIO_KEY: string;
      ZENDESK_CAIO_SUNSHINE_KEY: string;
      ZENDESK_HELP_CENTER_KEY: string;
      BLIP_HELPCENTER: string;
      ZENDESK_ID_FIELD_PRODUCER_EMAIL: string;
    };
  };
};

const settings: Settings = {
  production: {
    api: {
      'api-help-center': 'https://api-help-center.bkf.hotmart.com',
      'ticket-mobile': 'https://api-ticket-mobile.hotmart.com',
      'blip-api': 'https://msging.net',
      'authz-api': 'https://api-chat-authz.hotmart.com',
      'api-tickets': 'https://api-tickets-enriching.hotmart.com',
      'api-conversations': 'https://api-conversations-router.bkf.hotmart.com',
    },
    app: {
      backoffice: 'https://backoffice.hotmart.com',
    },
    keys: {
      BLIP_BW: process.env.BLIP_BW as string,
      BLIP_HELPCENTER: process.env.BLIP_HELPCENTER as string,
      ZENDESK_KEY: 'b8e5d9d9-39cc-4fda-b62a-c3d0490d63e9',
      ZENDESK_ASYNC_KEY: '2a0f856a-9cd8-47d5-be91-c5394b1fe4d4',
      ZENDESK_CAIO_KEY: '4970f2cd-dddf-4917-b30d-97d700295321',
      ZENDESK_CAIO_SUNSHINE_KEY: '6f0a5106-0446-4e77-8c89-cc596ffeafd3',
      ZENDESK_HELP_CENTER_KEY: 'a538c514-e23c-4ad5-a265-a7a547581bcd',
      ZENDESK_ID_FIELD_PRODUCER_EMAIL: '22574361411085',
    },
  },
  staging: {
    api: {
      'api-help-center': 'https://api-help-center.buildstaging.com',
      'ticket-mobile': 'https://api-ticket-mobile.buildstaging.com',
      'blip-api': 'https://msging.net',
      'api-tickets': 'https://api-tickets-enriching.buildstaging.com',
      'authz-api': 'https://api-chat-authz.buildstaging.com',
      'api-conversations': 'https://api-conversations-router.buildstaging.com',
    },
    app: {
      backoffice: 'https://app-backoffice.buildstaging.com',
    },
    keys: {
      BLIP_BW: process.env.BLIP_BW as string,
      BLIP_HELPCENTER: process.env.BLIP_HELPCENTER as string,
      ZENDESK_KEY: '36dd934d-d3be-4f79-ac5b-d35531f4445a',
      ZENDESK_ASYNC_KEY: 'dbcd0460-89b2-4c18-8828-51462023d9f1',
      ZENDESK_CAIO_KEY: '4fe8d5b6-754d-47fd-8c25-299ed05327d4',
      ZENDESK_CAIO_SUNSHINE_KEY: '40563b99-be37-4505-b883-5b979f6bde68',
      ZENDESK_HELP_CENTER_KEY: 'a538c514-e23c-4ad5-a265-a7a547581bcd',
      ZENDESK_ID_FIELD_PRODUCER_EMAIL: '22541584425357',
    },
  },
  development: {
    api: {
      'api-help-center': 'https://api-help-center.buildstaging.com',
      'ticket-mobile': 'https://api-ticket-mobile.buildstaging.com',
      'blip-api': 'https://msging.net',
      'authz-api': 'https://api-chat-authz.buildstaging.com',
      'api-tickets': 'https://api-tickets-enriching.buildstaging.com',
      'api-conversations': 'https://api-conversations-router.buildstaging.com',
    },
    app: {
      backoffice: 'https://app-backoffice.buildstaging.com',
    },
    keys: {
      BLIP_BW: process.env.BLIP_BW as string,
      BLIP_HELPCENTER: process.env.BLIP_HELPCENTER as string,
      ZENDESK_KEY: '36dd934d-d3be-4f79-ac5b-d35531f4445a',
      ZENDESK_ASYNC_KEY: 'dbcd0460-89b2-4c18-8828-51462023d9f1',
      ZENDESK_CAIO_KEY: '4fe8d5b6-754d-47fd-8c25-299ed05327d4',
      ZENDESK_CAIO_SUNSHINE_KEY: '40563b99-be37-4505-b883-5b979f6bde68',
      ZENDESK_HELP_CENTER_KEY: 'a538c514-e23c-4ad5-a265-a7a547581bcd',
      ZENDESK_ID_FIELD_PRODUCER_EMAIL: '22541584425357',
    },
  },
};

export default settings[file];
